import React, { useEffect, useState } from "react"
import { defineMessages, injectIntl } from "react-intl"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend/index"

import SurveyComponent from "../components/SurveyComponent"
import OnBoardingService from "../../state/onboarding/OnBoardingService"
import { isError } from "../../state/helpers/Error"
import { SIGN_UP_OPTION, START_UP_GUIDE_OPTION } from "../../state/onboarding/DataFlowTypes"
import { START_UP_GUIDE_OPTIONS } from "../../state/onboarding/DataFlowMaps"
import { INTEGRATION_KEY } from "../../state/integration/Constants"
import { Intl } from "../../state/helpers/IntlProps"

const titleMessages = defineMessages({
    [INTEGRATION_KEY.SHOPIFY]: {
        id: "onboarding.start_up_guide_survey.shopify_title",
        defaultMessage: "What are you trying to achieve ?",
    },
    [INTEGRATION_KEY.SHOPIFY_EXPERT_APP]: {
        id: "onboarding.start_up_guide_survey.shopify_title",
        defaultMessage: "What are you trying to achieve ?",
    },
})

const optionMessages = defineMessages({
    [START_UP_GUIDE_OPTION.REQUEST_A_QUOTE_FORM]: {
        id: "onboarding.start_up_guide_survey.option_request_a_quote_form",
        defaultMessage: "Add a Request a quote form",
    },
    [START_UP_GUIDE_OPTION.ADD_TO_QUOTE_BUTTON]: {
        id: "onboarding.start_up_guide_survey.option_add_to_quote_button",
        defaultMessage: "Add an “Add to Quote” button",
    },
    [START_UP_GUIDE_OPTION.HIDE_PRICE_ON_PRODUCT]: {
        id: "onboarding.start_up_guide_survey.option_hide_prices_on_products",
        defaultMessage: "Hide prices on products",
    },
    [START_UP_GUIDE_OPTION.SEND_QUOTES]: {
        id: "onboarding.start_up_guide_survey.option_send_quotes",
        defaultMessage: "Send customized quotes",
    },
    [START_UP_GUIDE_OPTION.SEND_INVOICES]: {
        id: "onboarding.start_up_guide_survey.option_send_invoices",
        defaultMessage: "Send invoices",
    },
    [START_UP_GUIDE_OPTION.DIGITAL_SIGNATURE]: {
        id: "onboarding.start_up_guide_survey.option_digital_signature",
        defaultMessage: "Capture digital signature",
    },
    [START_UP_GUIDE_OPTION.ACCOUNTS_RECEIVABLE]: {
        id: "onboarding.start_up_guide_survey.option_accounts_receivable",
        defaultMessage: "Manage your accounts receivable",
    },
    [START_UP_GUIDE_OPTION.TRACK_OPEN_DEALS]: {
        id: "onboarding.start_up_guide_survey.option_track_open_deals",
        defaultMessage: "Keep track of open deals",
    },
    [START_UP_GUIDE_OPTION.IPAD_FOR_POS_SHOPIFY]: {
        id: "onboarding.start_up_guide_survey.option_ipad_for_pos",
        defaultMessage: "I use an iPad for my Point of Sale (Shopify POS)",
    },
    [START_UP_GUIDE_OPTION.PAYMENT_TERMS]: {
        id: "onboarding.start_up_guide_survey.option_payment_terms",
        defaultMessage: "Add payment terms to certain sales",
    },
    [START_UP_GUIDE_OPTION.ONLINE_PAYMENTS]: {
        id: "onboarding.start_up_guide_survey.option_online_payment",
        defaultMessage: "Receive online payments for an invoice or a quote",
    },
    [START_UP_GUIDE_OPTION.PARTIAL_PAYMENTS_AND_DEPOSITS]: {
        id: "onboarding.start_up_guide_survey.option_partial_payments_and_deposits",
        defaultMessage: "Accept partial payments and deposits",
    },
    [START_UP_GUIDE_OPTION.SCHEDULE_APPOINTMENTS]: {
        id: "onboarding.start_up_guide_survey.option_schedule_appointments",
        defaultMessage: "Schedule appointments",
    },
    [START_UP_GUIDE_OPTION.SELL_ON_SOCIAL_MEDIA]: {
        id: "onboarding.start_up_guide_survey.option_sell_on_social_media",
        defaultMessage: "Sell on social media",
    },
    [START_UP_GUIDE_OPTION.SEND_SPECIAL_OFFERS]: {
        id: "onboarding.start_up_guide_survey.option_send_special_offers",
        defaultMessage: "Send special offers",
    },
})

type OwnProps = {
    intl: Intl,
    onStepCompleted: (payload) => object,
    step: string,
}

const StartUpGuideSurveyContainer = (props: OwnProps) => {
    const [surveyOptions, setSurveyOptions] = useState(new Set<START_UP_GUIDE_OPTION>())
    const integrationKey = AppContext.getAccount().attributes.integrationKey

    const onStepCompletedCallback = (selection) => {
        props.onStepCompleted({
            "startUpGuideSurveySelection": Array.from(selection)
        })
    }

    useEffect(() => {
        (async () => {
            const accountID = AppContext.getAccount().id
            const res = await OnBoardingService.GetDataFlow(accountID)
            if (!isError(res)) {
                await setSurveyOptions(getOptions(res.getSignUpSurveySelection()))
            }
        })()
    }, [])

    const getOptions = (initialSelection: Array<SIGN_UP_OPTION>): Set<START_UP_GUIDE_OPTION> => {
        const integrationOptions = START_UP_GUIDE_OPTIONS[integrationKey]
        const optionSet = new Set<START_UP_GUIDE_OPTION>()

        for (const selection of initialSelection) {
            integrationOptions[selection].forEach(opt => {
                optionSet.add(opt)
            })
        }
        return optionSet
    }

    return (
        <SurveyComponent
            onStepCompletedCallback={onStepCompletedCallback}
            title={props.intl.formatMessage(titleMessages[integrationKey])}
            options={Array.from(surveyOptions)}
            messages={optionMessages}
        />
    )
}

export default injectIntl(StartUpGuideSurveyContainer)


// WEBPACK FOOTER //
// ./src/onboarding/sections/StartUpGuideSurveyContainer.tsx